<DCO-header *ngIf="loadedStartup"></DCO-header>
<div>
  <router-outlet *ngIf="loadedStartup"></router-outlet>
</div>
<!-- <DCO-footer></DCO-footer> -->
<DCO-startup *ngIf="!loadedStartup"></DCO-startup>
@if(fallbackError){
  <DCO-fallback-error></DCO-fallback-error>
}
